import React, { useState } from 'react';
import { Modal, Button, Badge, Row, Col, Card } from 'react-bootstrap';
import { Icon } from '@iconify/react';

const OrderDetailsModal = ({ show, onHide, order }) => {
  const [showCopyAlert, setShowCopyAlert] = useState(false);
  const [showPaymentConfirm, setShowPaymentConfirm] = useState(false);
  
  if (!order) return null;

  const getStatusColor = (status) => {
    const colors = {
      'Em análise': 'warning',
      'Preparando': 'info',
      'Em rota': 'warning',
      'Entregue': 'success',
      'Falha': 'danger',
      'Entregue Cobrado': 'success',
      'Devolvido': 'secondary'
    };
    return colors[status] || 'secondary';
  };

  const getStatusIcon = (status) => {
    const icons = {
      'Em análise': 'mdi:clock-outline',
      'Preparando': 'mdi:package-variant',
      'Em rota': 'mdi:truck-delivery',
      'Entregue': 'mdi:check-circle',
      'Falha': 'mdi:alert-circle',
      'Entregue Cobrado': 'mdi:cash-multiple',
      'Devolvido': 'mdi:package-variant-remove'
    };
    return icons[status] || 'mdi:information';
  };

  return (
    <>
      <Modal 
        show={show} 
        onHide={onHide} 
        size="xl" 
        centered 
        style={{ zIndex: 10000 }}
        backdrop="static"
        backdropClassName="modal-backdrop-lightbox"
        data-bs-theme={document.documentElement.getAttribute('data-theme')}
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title className="d-flex align-items-center gap-2">
            <Icon icon="mdi:file-document-outline" />
            Detalhes do Pedido #{order.id}
          </Modal.Title>
        </Modal.Header>
        
        <Modal.Body className="p-4">
          <Row className="g-3" style={{ margin: '12px', padding: '0 12px' }}>
            {/* Informações do Pedido */}
            <Col lg={4}>
              <Card className="border border-light h-100" style={{ boxShadow: 'none' }}>
                <Card.Header className="bg-light">
                                  <span className="mb-0 d-flex align-items-center gap-2 fw-bold" style={{ fontSize: '1.0rem' }}>
                  <Icon icon="mdi:file-document" className="text-primary" />
                  Informações do Pedido
                </span>
                </Card.Header>
                <Card.Body className="p-4">
                  <div className="px-3">
                    <div className="d-flex flex-column gap-2">
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Número do Pedido</span>
                        <span className="text-primary fw-bold" style={{ fontSize: '0.85rem' }}>#{order.id}</span>
                      </div>
                      
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Data do Pedido</span>
                        <span style={{ fontSize: '0.85rem' }}>{order.date}</span>
                      </div>
                      
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Produto</span>
                        <span style={{ fontSize: '0.85rem' }}>{order.product}</span>
                      </div>
                      
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Tratamento</span>
                        <span style={{ fontSize: '0.85rem' }}>{order.treatment}</span>
                      </div>
                      
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Valor Total</span>
                        <span className="text-success fw-bold" style={{ fontSize: '0.85rem' }}>{order.totalValue}</span>
                      </div>
                      
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Status</span>
                        <Badge bg={getStatusColor(order.status)} className="d-flex align-items-center gap-1" style={{ fontSize: '0.75rem' }}>
                          <Icon icon={getStatusIcon(order.status)} style={{ fontSize: '0.65rem' }} />
                          {order.status}
                        </Badge>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Dados do Cliente */}
            <Col lg={4}>
              <Card className="border border-light h-100" style={{ boxShadow: 'none' }}>
                <Card.Header className="bg-light">
                                  <span className="mb-0 d-flex align-items-center gap-2 fw-bold" style={{ fontSize: '1.0rem' }}>
                  <Icon icon="mdi:account" className="text-primary" />
                  Dados do Cliente
                </span>
                </Card.Header>
                <Card.Body className="p-4">
                  <div className="px-3">
                    <div className="d-flex flex-column gap-2">
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Nome</span>
                        <span style={{ fontSize: '0.85rem' }}>{order.customer?.name}</span>
                      </div>
                      
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Email</span>
                        <span style={{ fontSize: '0.85rem' }}>{order.customer?.email}</span>
                      </div>
                      
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>CPF</span>
                        <span style={{ fontSize: '0.85rem' }}>{order.customer?.cpf}</span>
                      </div>
                      
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Telefone</span>
                        <span style={{ fontSize: '0.85rem' }}>{order.customer?.phone}</span>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Endereço de Entrega */}
            <Col lg={4}>
              <Card className="border border-light h-100" style={{ boxShadow: 'none' }}>
                <Card.Header className="bg-light">
                                  <span className="mb-0 d-flex align-items-center gap-2 fw-bold" style={{ fontSize: '1.0rem' }}>
                  <Icon icon="mdi:map-marker" className="text-primary" />
                  Endereço de Entrega
                </span>
                </Card.Header>
                <Card.Body className="p-4">
                  <div className="px-3">
                    <div className="d-flex flex-column gap-2">
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Rua</span>
                        <span style={{ fontSize: '0.85rem' }}>{order.address?.street}</span>
                      </div>
                      
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Bairro</span>
                        <span style={{ fontSize: '0.85rem' }}>{order.address?.neighborhood}</span>
                      </div>
                      
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Cidade/UF</span>
                        <span style={{ fontSize: '0.85rem' }}>{order.address?.city} - {order.address?.state}</span>
                      </div>
                      
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>CEP</span>
                        <span style={{ fontSize: '0.85rem' }}>{order.address?.zipCode}</span>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="g-3" style={{ margin: '12px', padding: '0 12px' }}>
            {/* Dados de Envio */}
            <Col lg={12}>
              <Card className="border border-light" style={{ boxShadow: 'none' }}>
                <Card.Header className="bg-light">
                                  <span className="mb-0 d-flex align-items-center gap-2 fw-bold" style={{ fontSize: '1.0rem' }}>
                  <Icon icon="mdi:truck-delivery" className="text-primary" />
                  Dados de Envio
                </span>
                </Card.Header>
                <Card.Body className="p-4">
                  <div className="px-3">
                    <Row>
                      <Col lg={6}>
                        <div className="d-flex flex-column gap-2">
                          <div className="d-flex flex-column">
                            <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Status Atual</span>
                            <Badge bg={getStatusColor(order.status)} className="d-flex align-items-center gap-1" style={{ fontSize: '0.75rem' }}>
                              <Icon icon={getStatusIcon(order.status)} style={{ fontSize: '0.65rem' }} />
                              {order.status}
                            </Badge>
                          </div>
                          
                          <div className="d-flex flex-column">
                            <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Última atualização</span>
                            <span style={{ fontSize: '0.85rem' }}>{order.lastUpdateDate ? new Date(order.lastUpdateDate).toLocaleString('pt-BR', { 
                              day: '2-digit', 
                              month: '2-digit', 
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              timeZone: 'America/Sao_Paulo'
                            }) : 'Não disponível'}</span>
                          </div>
                          
                          <div className="d-flex flex-column">
                            <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Código de Rastreio</span>
                            <span className="font-monospace" style={{ fontSize: '0.85rem' }}>
                              {order.trackingCode || 'Sem código de rastreio'}
                            </span>
                          </div>
                          
                          <div className="mt-2 mb-3 d-flex gap-2">
                            <Button 
                              variant="outline-secondary" 
                              size="sm" 
                              className="flex-fill"
                              disabled={!order.trackingCode}
                              onClick={() => {
                                if (order.trackingCode) {
                                  navigator.clipboard.writeText(order.trackingCode);
                                  setShowCopyAlert(true);
                                  setTimeout(() => setShowCopyAlert(false), 3000);
                                }
                              }}
                            >
                              <Icon icon="mdi:content-copy" className="me-1" />
                              Copiar Código
                            </Button>
                            <Button 
                              variant="outline-primary" 
                              size="sm" 
                              className="flex-fill"
                              disabled={!order.trackingCode}
                              onClick={() => {
                                if (order.trackingCode) {
                                  window.open(`https://rastreamento.correios.com.br/app/index.php?objeto=${order.trackingCode}`, '_blank');
                                }
                              }}
                            >
                              <Icon icon="mdi:map-search" className="me-1" />
                              Ver no Site
                            </Button>
                          </div>
                        </div>
                      </Col>
                      
                      <Col lg={6}>
                        {/* Comprovante de Entrega */}
                        <div className="p-3 bg-light rounded" style={{ marginBottom: '1rem' }}>
                          <div className="d-flex align-items-center gap-2 mb-2">
                            <Icon icon="mdi:file-image" className="text-success" />
                            <strong style={{ fontSize: '0.9rem' }}>Comprovante de Entrega</strong>
                          </div>
                          <div className="text-center">
                            <div className="bg-white border rounded p-3 mb-2">
                              <Icon icon="mdi:camera" style={{ fontSize: '2rem', color: '#6c757d' }} />
                              <div className="text-muted small mt-2">
                                {order.deliveredAt ? 'Foto disponível no site dos Correios' : 'Aguardando entrega'}
                              </div>
                            </div>
                            {order.trackingCode && order.deliveredAt && (
                              <Button 
                                variant="success" 
                                size="sm"
                                onClick={() => window.open(`https://rastreamento.correios.com.br/app/index.php?objeto=${order.trackingCode}`, '_blank')}
                              >
                                <Icon icon="mdi:image-search" className="me-1" />
                                Ver Foto do Comprovante
                              </Button>
                            )}
                            {!order.deliveredAt && (
                              <div className="text-muted small">
                                A foto estará disponível após a entrega
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="g-3" style={{ margin: '12px', padding: '0 12px' }}>
            {/* Vinculação de Checkout */}
            <Col lg={6}>
              <Card className="border border-light h-100" style={{ boxShadow: 'none' }}>
                <Card.Header className="bg-warning bg-opacity-10">
                                  <span className="mb-0 d-flex align-items-center gap-2 fw-bold" style={{ fontSize: '1.0rem' }}>
                  <Icon icon="mdi:link-variant" className="text-warning" />
                  Vinculação de Checkout
                </span>
                </Card.Header>
                <Card.Body className="p-4">
                  <div className="px-3">
                    <div className="d-flex flex-column gap-2">
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Status da Vinculação</span>
                        <span className={`fw-bold ${order.checkoutStatus === 'linked' ? 'text-success' : 'text-warning'}`} style={{ fontSize: '0.85rem' }}>
                          {order.checkoutStatus === 'linked' ? 'Vinculado' : 'Pendente'}
                        </span>
                      </div>
                      
                      <div className="d-flex flex-column">
                        <span className="text-muted fw-bold" style={{ fontSize: '0.8rem' }}>Descrição</span>
                        <span style={{ fontSize: '0.85rem' }}>
                          {order.checkoutDescription || 'O link de checkout só estará disponível após a vinculação da oferta na plataforma.'}
                        </span>
                      </div>
                      
                      <div className="mt-2">
                        <Button variant="outline-warning" size="sm">
                          <Icon icon="mdi:link-plus" className="me-1" />
                          Clique aqui para vincular
                        </Button>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Atualizações de Envio */}
            <Col lg={6}>
              <Card className="border border-light h-100" style={{ boxShadow: 'none' }}>
                <Card.Header className="bg-light">
                                  <span className="mb-0 d-flex align-items-center gap-2 fw-bold" style={{ fontSize: '1.0rem' }}>
                  <Icon icon="mdi:history" className="text-primary" />
                  Atualizações de Envio
                </span>
                </Card.Header>
                <Card.Body className="p-4">
                  <div className="px-3">
                    <div className="timeline" style={{ paddingTop: '8px' }}>
                      {order.trackingHistory && order.trackingHistory.length > 0 ? (
                        order.trackingHistory.map((update, index) => (
                          <div key={index} className="timeline-item">
                            <div className={`timeline-marker bg-${getStatusColor(update.status)}`}>
                              <Icon icon={getStatusIcon(update.status)} className="text-white" />
                            </div>
                            <div className="timeline-content">
                              <div className="d-flex justify-content-between align-items-start">
                                <div>
                                  <strong>Pedido teve atualização para {update.status}</strong>
                                  <div className="text-muted small">
                                    {update.date ? new Date(update.date).toLocaleString('pt-BR', { 
                                      day: '2-digit', 
                                      month: '2-digit', 
                                      year: 'numeric',
                                      hour: '2-digit',
                                      minute: '2-digit',
                                      timeZone: 'America/Sao_Paulo'
                                    }) : 'Data não disponível'}
                                  </div>
                                  {update.description && (
                                    <div className={`text-${getStatusColor(update.status)} small`}>
                                      {update.description}
                                    </div>
                                  )}
                                  {update.location && (
                                    <div className="text-muted small">Local: {update.location}</div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center text-muted py-3">
                          <Icon icon="mdi:information-outline" className="me-2" />
                          Nenhuma atualização de rastreamento disponível
                        </div>
                      )}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Ação do Atendente - Apenas se requer atenção */}
          {order.attentionPriority > 0 && (
            <div className="mt-3 p-3 bg-danger bg-opacity-10 border border-danger rounded" style={{ margin: '12px' }}>
              <div className="d-flex align-items-start gap-3">
                <Icon icon="mdi:alert-circle" className="text-danger" style={{ fontSize: '1.5rem', marginTop: '2px' }} />
                <div className="flex-grow-1">
                  <strong className="text-danger d-block mb-1">⚠️ Este pedido requer atenção urgente!</strong>
                  <div className="text-dark mb-2" style={{ fontSize: '0.9rem' }}>
                    <strong>Motivo:</strong> {order.attentionReason || 'Situação requer intervenção'}
                  </div>
                  {order.attentionPriority && (
                    <Badge 
                      bg={order.attentionPriority === 3 ? 'danger' : order.attentionPriority === 2 ? 'warning' : 'info'}
                      className="mb-2"
                    >
                      Prioridade {order.attentionPriority}
                    </Badge>
                  )}
                  <div className="text-muted small">
                    {order.trackingDescription || 'Verifique o status no site dos Correios'}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Ação de Pagamento - Apenas se entregue mas não pago */}
          {order.deliveredAt && order.paymentStatus !== 'paid' && (
            <div className="mt-3 p-3 bg-warning bg-opacity-10 border border-warning rounded" style={{ margin: '12px' }}>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2">
                  <Icon icon="mdi:cash-clock" className="text-warning" />
                  <strong className="text-warning">Aguardando pagamento do cliente</strong>
                </div>
                <Button 
                  variant="warning" 
                  size="sm"
                  onClick={() => setShowPaymentConfirm(true)}
                >
                  <Icon icon="mdi:cash-multiple" className="me-1" />
                  Declarar como Pago
                </Button>
              </div>
            </div>
          )}
        </Modal.Body>
        
        <Modal.Footer>
          <Button 
            variant="light" 
            onClick={onHide}
            style={{
              borderRadius: '8px',
              padding: '10px 20px',
              fontWeight: '500',
              border: '1px solid rgba(108, 117, 125, 0.2)',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex'
              
            }}
          >
            <Icon icon="mdi:close" className="me-2" />
            Fechar
          </Button>
          <Button 
            variant="primary"
            style={{
              borderRadius: '8px',
              padding: '10px 20px',
              fontWeight: '500'
            }}
          >
            <Icon icon="mdi:content-save" className="me-2" />
            Salvar Alterações
          </Button>
        </Modal.Footer>
      </Modal>
      
      {/* Alert de Sucesso para Copiar Código */}
      {showCopyAlert && (
        <div 
          className="position-fixed top-0 start-50 translate-middle-x mt-4"
          style={{ zIndex: 10001 }}
        >
          <div className="alert alert-success d-flex align-items-center gap-2 shadow-sm" style={{ minWidth: '300px' }}>
            <Icon icon="mdi:check-circle" style={{ fontSize: '1.2rem' }} />
            <span>Código copiado para a área de transferência!</span>
          </div>
        </div>
      )}

      {/* Modal de Confirmação de Pagamento */}
      <Modal show={showPaymentConfirm} onHide={() => setShowPaymentConfirm(false)} centered style={{ zIndex: 10002 }}>
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center gap-2">
            <Icon icon="mdi:cash-multiple" className="text-warning" />
            Confirmar Pagamento
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center mb-3">
            <Icon icon="mdi:help-circle" className="text-warning" style={{ fontSize: '3rem' }} />
          </div>
          <p className="text-center mb-3">
            Tem certeza que deseja marcar o pedido <strong>#{order?.id}</strong> como <strong>PAGO</strong>?
          </p>
          <div className="alert alert-warning d-flex align-items-center gap-2">
            <Icon icon="mdi:information" />
            <small>Esta ação irá alterar o status do pedido no banco de dados.</small>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPaymentConfirm(false)}>
            Cancelar
          </Button>
          <Button 
            variant="warning"
            onClick={async () => {
              try {
                // TODO: Implementar chamada para o backend
                // const response = await fetch(`/api/orders/${order.id}/mark-paid`, {
                //   method: 'PUT',
                //   headers: {
                //     'Content-Type': 'application/json',
                //     'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
                //   }
                // });
                
                console.log(`Pedido ${order?.id} marcado como pago!`);
                setShowPaymentConfirm(false);
                setShowCopyAlert(true);
                setTimeout(() => setShowCopyAlert(false), 3000);
                
                // TODO: Atualizar estado do pedido na tela principal
              } catch (error) {
                console.error('Erro ao marcar como pago:', error);
                alert('Erro ao processar pagamento. Tente novamente.');
              }
            }}
          >
            <Icon icon="mdi:check" className="me-1" />
            Sim, Confirmar Pagamento
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OrderDetailsModal; 